import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { getUserPermissions } from "../config/cardRegistry";
import "./PlaceholderPage.css";
import "./AIAgents.css";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001/api";

const AIAgents = () => {
    const navigate = useNavigate();
    const userPermissions = getUserPermissions();
    const [registrazioniDaRevisionare, setRegistrazioniDaRevisionare] = useState(0);

    useEffect(() => {
        if (!userPermissions.includes("ai_agents.registrazioni")) return;
        // Solo il conteggio: la lista completa (prima scaricata qui per intero,
        // trascrizioni comprese) non serve al badge.
        const token = localStorage.getItem("token");
        axios.get(`${API_URL}/registrazioni/count`, { headers: { Authorization: `Bearer ${token}` }, timeout: 15000 })
            .then((res) => setRegistrazioniDaRevisionare(Number(res.data?.daRevisionare) || 0))
            .catch(() => {});
    }, [userPermissions]);

    return (
        <div className="placeholder-container ai-agents-container">
            <header className="page-header">
                <div className="header-content">
                    <div className="header-title">
                        <h2>AI Agents</h2>
                        <p className="header-subtitle">
                            Agenti AI intelligenti per analisi avanzata e supporto decisionale
                        </p>
                    </div>
                </div>
            </header>

            <div className="content-area">
                <div className="ai-agents-grid">
                    {/* Card RAG - Bandi & Chat (launcher: naviga a /rag) */}
                    {userPermissions.includes("ai_agents.rag") && (
                        <div
                            className="ai-agent-card ai-agent-card-launcher"
                            onClick={() => navigate("/rag")}
                            role="button"
                            tabIndex={0}
                        >
                            <div className="ai-agent-card-header">
                                <div className="ai-agent-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
                                        <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
                                    </svg>
                                </div>
                                <div>
                                    <h3 className="ai-agent-card-title">RAG - Bandi & Chat</h3>
                                    <p className="ai-agent-card-description">
                                        Carica bandi PDF, estrai informazioni e fai domande in linguaggio naturale con citazioni cliccabili
                                    </p>
                                </div>
                            </div>

                            <div className="ai-agent-card-footer">
                                <span>Apri RAG</span>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="9 18 15 12 9 6" />
                                </svg>
                            </div>
                        </div>
                    )}

                    {/* Card Agente Controllo Rendicontazioni */}
                    {userPermissions.includes("ai_agents.controllo_rendicontazioni") && (
                        <div
                            className="ai-agent-card ai-agent-card-launcher"
                            onClick={() => navigate("/agente-controllo-rendicontazioni")}
                            role="button"
                            tabIndex={0}
                        >
                            <div className="ai-agent-card-header">
                                <div className="ai-agent-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M9 2h6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z" />
                                        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
                                        <polyline points="9 14 11 16 15 12" />
                                    </svg>
                                </div>
                                <div>
                                    <h3 className="ai-agent-card-title">Agente Controllo Rendicontazioni</h3>
                                    <p className="ai-agent-card-description">
                                        Valida automaticamente la rendicontazione mensile di ore lavorate e buoni pasto, rilevando anomalie su turni, riposi, scostamenti e spettanze
                                    </p>
                                </div>
                            </div>

                            <div className="ai-agent-card-footer">
                                <span>Apri Agente</span>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="9 18 15 12 9 6" />
                                </svg>
                            </div>
                        </div>
                    )}

                    {/* Card Simulatore Costi Dipendente (launcher: naviga a /simulatore-costi-dipendenti) */}
                    {userPermissions.includes("ai_agents.simulatore_costi_dipendenti") && (
                        <div
                            className="ai-agent-card ai-agent-card-launcher"
                            onClick={() => navigate("/simulatore-costi-dipendenti")}
                            role="button"
                            tabIndex={0}
                        >
                            <div className="ai-agent-card-header">
                                <div className="ai-agent-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <rect x="4" y="2" width="16" height="20" rx="2" ry="2" />
                                        <line x1="8" y1="6" x2="16" y2="6" />
                                        <line x1="8" y1="10" x2="10" y2="10" />
                                        <line x1="12" y1="10" x2="14" y2="10" />
                                        <line x1="8" y1="14" x2="10" y2="14" />
                                        <line x1="12" y1="14" x2="14" y2="14" />
                                        <line x1="8" y1="18" x2="10" y2="18" />
                                        <line x1="12" y1="18" x2="14" y2="18" />
                                    </svg>
                                </div>
                                <div>
                                    <h3 className="ai-agent-card-title">Simulatore Costi Dipendente</h3>
                                    <p className="ai-agent-card-description">
                                        Netto, costo azienda e costo orario reale da livello CCNL e ore, con le regole fiscali 2026
                                    </p>
                                </div>
                            </div>

                            <div className="ai-agent-card-footer">
                                <span>Apri Simulatore</span>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="9 18 15 12 9 6" />
                                </svg>
                            </div>
                        </div>
                    )}

                    {/* Card Registrazioni & Sintesi Call (launcher: naviga a /registrazioni-call) */}
                    {userPermissions.includes("ai_agents.registrazioni") && (
                        <div
                            className="ai-agent-card ai-agent-card-launcher"
                            onClick={() => navigate("/registrazioni-call")}
                            role="button"
                            tabIndex={0}
                        >
                            <div className="ai-agent-card-header">
                                <div className="ai-agent-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M23 7l-7 5 7 5V7z" />
                                        <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
                                    </svg>
                                </div>
                                <div>
                                    <h3 className="ai-agent-card-title">Registrazioni &amp; Sintesi Call</h3>
                                    <p className="ai-agent-card-description">
                                        Registra videocall e riunioni, genera trascrizione e sintesi AI, pubblica su Interacta dopo la revisione
                                    </p>
                                </div>
                            </div>

                            <div className="ai-agent-card-footer">
                                <span>Apri Registrazioni</span>
                                {registrazioniDaRevisionare > 0 && (
                                    <span className="ai-agent-card-badge">{registrazioniDaRevisionare} da revisionare</span>
                                )}
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginLeft: "auto" }}>
                                    <polyline points="9 18 15 12 9 6" />
                                </svg>
                            </div>
                        </div>
                    )}

                    {/* Card Chatbot AI (launcher: naviga a /chatbot-ai) */}
                    {userPermissions.includes("ai_agents.chatbot") && (
                        <div
                            className="ai-agent-card ai-agent-card-launcher"
                            onClick={() => navigate("/chatbot-ai")}
                            role="button"
                            tabIndex={0}
                        >
                            <div className="ai-agent-card-header">
                                <div className="ai-agent-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                                    </svg>
                                </div>
                                <div>
                                    <h3 className="ai-agent-card-title">LF23 Chatbot</h3>
                                    <p className="ai-agent-card-description">
                                        Assistente conversazionale multi-provider (ChatGPT, Claude, ...) con storico delle chat e condivisione
                                    </p>
                                </div>
                            </div>

                            <div className="ai-agent-card-footer">
                                <span>Apri Chatbot</span>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="9 18 15 12 9 6" />
                                </svg>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AIAgents;
